import apiClient from './client'

export interface HealthResponse {
  status: 'ok' | 'error'
  mode: 'demo' | 'prod'
  database: 'connected' | 'disconnected'
  timestamp: string
}

export async function fetchHealth(): Promise<HealthResponse> {
  const { data } = await apiClient.get<HealthResponse>('/health')
  return data
}
